import React from "react";
import { Phone, Mail, MapPin, Globe, Heart, Facebook, Instagram, Twitter } from "lucide-react";
import { company, navLinks, services } from "../mock";

const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    const el = document.getElementById(href.replace("#", ""));
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 78, behavior: "smooth" });
  };

  return (
    <footer style={{ background: "var(--navy-deep)" }} className="text-white/75">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="bg-white rounded-xl inline-block p-3">
            <img src={company.logo} alt={company.legal} className="h-12 w-auto" />
          </div>
          <p className="mt-5 text-[15px] leading-relaxed">
            {company.legal} provides quality, loving, in-home care for families just
            like yours across South Florida.
          </p>
          <p className="font-script text-2xl text-[#f2a25a] mt-4">{company.tagline}</p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Instagram, Twitter].map((Ic, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#e07c24] transition-colors text-white">
                <Ic size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-display font-bold text-lg mb-5">Navigation</h4>
          <ul className="space-y-3 text-[15px]">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={(e) => go(e, l.href)} className="hover:text-[#f2a25a] transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-bold text-lg mb-5">Services</h4>
          <ul className="space-y-3 text-[15px]">
            {services.slice(0, 6).map((s) => (
              <li key={s.title}>
                <a href="#services" onClick={(e) => go(e, "#services")} className="hover:text-[#f2a25a] transition-colors">
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-display font-bold text-lg mb-5">Contact</h4>
          <ul className="space-y-4 text-[15px]">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-[#f2a25a] shrink-0 mt-0.5" /> {company.address}
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-[#f2a25a] shrink-0" />
              <a href={`tel:${company.phoneLink}`} className="hover:text-[#f2a25a]">{company.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-[#f2a25a] shrink-0" />
              <a href={`mailto:${company.email}`} className="hover:text-[#f2a25a] break-all">{company.email}</a>
            </li>
            <li className="flex items-center gap-3">
              <Globe size={18} className="text-[#f2a25a] shrink-0" />
              <a href={company.websiteLink} className="hover:text-[#f2a25a]">{company.website}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
          <p>&copy; {new Date().getFullYear()} {company.legal}. All Rights Reserved.</p>
          <p className="flex items-center gap-1.5">
            Made with <Heart size={14} className="text-[#e07c24] fill-[#e07c24]" /> By{" "}
            <a
              href="https://www.sparkplug.one"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#f2a25a] hover:text-white transition-colors font-semibold"
            >
              Spark Plug
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
